import { render, staticRenderFns } from "./AlbumPicker.vue?vue&type=template&id=3feba8ee&scoped=true"
import script from "./AlbumPicker.vue?vue&type=script&lang=ts"
export * from "./AlbumPicker.vue?vue&type=script&lang=ts"
import style0 from "./AlbumPicker.vue?vue&type=style&index=0&id=3feba8ee&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3feba8ee",
  null
  
)

export default component.exports